import { readRunSummaries } from "./runSummaries";
import { useQuery, type QueryClient } from "@tanstack/react-query";
import { api } from "./api";

export const useDatasets = () => useQuery({ queryKey: ["datasets"], queryFn: api.datasets, staleTime:60_000, refetchOnWindowFocus:false });
export const useSuites = () => useQuery({ queryKey: ["suites"], queryFn: api.suites });
export const useRuns = () => useQuery({ queryKey: ["runs"], queryFn: api.runs, refetchInterval: 5_000 });
export const useAnalysis = (filters: { runId?: string; provider?: string; datasetId?: string; dateFrom?: string; dateTo?: string; page?: number; pageSize?: number }) =>
  useQuery({
    queryKey: ["analysis", filters],
    queryFn: ({ signal }) => api.analysis(filters, signal),
    placeholderData: (previous, previousQuery) => {
      const old = previousQuery?.queryKey[1] as typeof filters | undefined;
      return old && (["runId", "provider", "datasetId", "dateFrom", "dateTo"] as const)
        .every((key) => old[key] === filters[key]) ? previous : undefined;
    },
    refetchInterval: 30_000,
  });
export const useBadCases = () => useQuery({ queryKey: ["bad-cases"], queryFn: () => api.badCases() });
export const useCandidates = (runId?: string) =>
  useQuery({
    queryKey: ["candidates", runId],
    queryFn: () => api.candidates(runId!),
    enabled: Boolean(runId),
    refetchInterval: 5_000,
  });


export const useRunSummaries = (filters: import("./runSummaries").RunSummaryFilters) => useQuery({
  queryKey: ["runs", "summaries", filters],
  queryFn: ({ signal }) => readRunSummaries(filters, signal),
  refetchInterval: 5_000,
});

export const useBadCaseSummary = () => useQuery({queryKey:["bad-case-audio-groups","dashboard"],queryFn:()=>api.badCaseAudioGroups(),refetchInterval:30_000,retry:false});

export function invalidateReviewReadModels(client: Pick<QueryClient, "invalidateQueries">, onError: () => void): void {
  const keys = ["review-audio-groups", "review-queue-stats", "bad-cases", "bad-case-audio-groups", "runs"];
  void Promise.all(keys.map(key => client.invalidateQueries({ queryKey: [key] }, { throwOnError: true }))).catch(onError);
}
